import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as config from "../../../../constants/config";
import * as license from "../../../../constants/license";
import * as resources from "../../../../constants/resources";
import * as componentTypes from "../../../../constants/componentTypes";
import * as globalActions from "../../../../actions/globalActions";
import * as licenseActions from "../../../../actions/licenseActions";
import * as navigationActions from "../../../../actions/navigationActions";

import Button, {BUTTON_SMALL, BUTTON_VARIANT_LINK} from "../../../global/generic/Button";

import imgCopy from "../../../../resources/img/svgicons/copy.svg";
import imgReset from "../../../../resources/img/svgicons/reset.svg";
import imgSkip from "../../../../resources/img/svgicons/skip.svg";
import imgBack from "../../../../resources/img/svgicons/arrow-left-circle.svg";
import imgNewLicense from "../../../../resources/img/svgicons/license-new.svg";

class LicenseRequest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            license: ""
        };
    }

    handleCopyClick = () => {
        window.jQuery("#hiddenInput").val(this.props.request ?? "");
        window.jQuery("#hiddenInput").select();

        document.execCommand("copy");
    };

    handleGoBackButtonClick = () => {
        this.props.dispatchGoBackAction(this.props.processStep - 1);
    };

    handleRemoveLicenseRequestClick = () => {
        this.props.dispatchRemoveLicenseRequestAction();
    };

    handleLicenseChange = (event) => {
        this.setState({
            license: event.target.value
        });
    };

    handleConfirmLicenseFormClick = () => {
        if (this.state.license.length > 0) {
            this.props.dispatchInstallLicenseAction(this.state.license);
        }
    };

    handleContinueToRedlikeClick = () => {
        this.props.dispatchStartSoftwareInitializationAction();
    };

    handleWebLinkClick = () => {
        this.props.dispatchOpenWebviewModalWithParams({
            link: config.REGISTRATION_LICENSE,
            title: translate("license.activateLicense")
        });
    };

    getActivateButton = () => {
        return (
            <Button
                size={BUTTON_SMALL}
                label={<Translate value="license.activateLicense" />}
                svgBefore={imgNewLicense}
                onClick={this.handleConfirmLicenseFormClick}
                disabled={this.state.license.length === 0}
            />
        );
    };

    getSkipNewLicenseButton = () => {
        if (this.props.setupSoftware || this.props.licenseStatus !== license.STATUS_VALID_LEASED_LICENSE) {
            return "";
        }

        return (
            <Button
                size={BUTTON_SMALL}
                label={<Translate value="license.skip" />}
                svgBefore={imgSkip}
                onClick={this.handleContinueToRedlikeClick}
            />
        );
    };

    getWebLink = () => {
        if (this.props.loggedUser.canEdit(resources.FUNCTION_OPEN_BROWSER)) {
            return (
                <a href={config.REGISTRATION_LICENSE} target="_blank" rel="noopener noreferrer">
                    {config.REGISTRATION_LICENSE}
                </a>
            );
        }

        return (
            <Button
                size={BUTTON_SMALL}
                variant={BUTTON_VARIANT_LINK}
                label={config.REGISTRATION_LICENSE}
                onClick={this.handleWebLinkClick}
            />
        );
    };

    render() {
        return (
            <div className="flex flex-column flex-child fill-flex-space">
                <div className="form-box-dark-blue row flex-child fill-flex-space flex flex-wrap flex-align-center padding-5">
                    <div className="col-12 license-text">
                        <Translate value="license.insertLicense" />
                    </div>
                    <div className="col-12 flex flex-space-between">
                        <textarea className="license-key-input" value={this.props.request ?? ""} readOnly />
                        <div className="col-2 flex flex-column flex-gap-3vh flex-wrap">
                            <Button
                                size={BUTTON_SMALL}
                                label={translate("license.copy")}
                                svgBefore={imgCopy}
                                disabled={this.props.request === null}
                                onClick={this.handleCopyClick}
                            />
                            <Button
                                size={BUTTON_SMALL}
                                label={translate("general.reset")}
                                svgBefore={imgReset}
                                disabled={this.props.request === null}
                                onClick={this.handleRemoveLicenseRequestClick}
                            />
                        </div>
                        <textarea className="license-key-input" onChange={this.handleLicenseChange} />
                    </div>
                    <div className="col-12 text-center license-link-container color-primary">
                        <Translate value="license.registerLicense" />
                        &nbsp;
                        {this.getWebLink()}
                    </div>
                </div>
                <div className="col-12 flex flex-align-center flex-gap-3vh margin-bottom-10">
                    <Button
                        size={BUTTON_SMALL}
                        label={<Translate value="general.back" />}
                        svgBefore={imgBack}
                        onClick={this.handleGoBackButtonClick}
                    />
                    {this.getActivateButton()}
                    {this.getSkipNewLicenseButton()}
                </div>
                <input type="text" id="hiddenInput" name="hidden" className="offscreen" />
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        loggedUser: store.login.loggedUser,
        setupSoftware: store.module.setupSoftware,
        licenseStatus: store.license.licenseStatus,
        processStep: store.license.processStep,
        request: store.license.request
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchStartSoftwareInitializationAction: () => {
            dispatch(globalActions.startSoftwareInitialization());
        },
        dispatchGoBackAction: (toStep) => {
            dispatch(licenseActions.setStep(toStep));
        },
        dispatchRemoveLicenseRequestAction: () => {
            dispatch(licenseActions.removeLicenseRequest());
        },
        dispatchInstallLicenseAction: (license) => {
            dispatch(licenseActions.installLicense(license));
        },
        dispatchOpenWebviewModalWithParams: (params) => {
            dispatch(
                navigationActions.openModalWithParams(componentTypes.MODAL_NO_TAB, componentTypes.WEBVIEW_MODAL, params)
            );
        }
    };
};

export default LicenseRequest = connect(mapStoreToProps, mapDispatchToProps)(LicenseRequest);
